import dynamic from 'next/dynamic';
import { ReactNode } from 'react';

import { Props } from './table-list';

export const TableList = dynamic(() => import('./table-list'), { ssr: false }) as <I>(props: Props<I>) => ReactNode;
